import { Component, OnDestroy } from '@angular/core';
import { BaseWidgetComponent } from '../widget/base/base-widget';
import { WidgetDataService } from '../widget/data/widget-data.service';
import { MachineInfoMainService } from '../../../../shared/services/machine-info.service';
import { CommonModule } from '@angular/common';
import { MachineOwnerService } from 'src/app/shared/services/owner.service';
import { DxButtonModule, DxTemplateModule } from 'devextreme-angular';
import { MachineInfo } from 'src/api/generated';
import { IBaseWidgetConfig } from '../widget/base/widget-list';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TranslateWithFallbackPipe } from 'acl-cloud-lib';
import { RemoteDataWrapperService } from '../../../../shared/services/remote-data/remote-data-wrapper.service';
import { MachineStructureTreeListComponent } from "../../../../shared/components/machine-structure-tree-list/machine-structure-tree-list.component";
import { DashboardDataService } from '../../data/dashboard-data.service';

export interface MachineInfoWidgetConfig extends IBaseWidgetConfig {
  machineId: string | null;
  refreshInterval: number;
}

@Component({
  selector: 'app-machine-info',
  standalone: true,
  imports: [CommonModule, DxButtonModule, DxTemplateModule, MachineStructureTreeListComponent],
  templateUrl: './machine-info.component.html',
  styleUrl: './machine-info.component.scss'
})
export class MachineInfoComponent extends BaseWidgetComponent<MachineInfoWidgetConfig> implements OnDestroy {
  
  public machineInfo: MachineInfo = {} as MachineInfo;
  private _refreshInterval: any;

  constructor(
    widgetDataService: WidgetDataService<MachineInfoWidgetConfig>,
    remoteDataWrapperService: RemoteDataWrapperService,
    private readonly _router: Router,
    private readonly _notification: ToastrService,
    private readonly _miSvc: MachineInfoMainService,
    private readonly _oSvc: MachineOwnerService,
    private readonly _translation: TranslateWithFallbackPipe
  ) {
    super(widgetDataService, remoteDataWrapperService);
  }

  protected override setOptions(options: MachineInfoWidgetConfig): void {
    this.options = options;

    if (this._miSvc.CurrentMachine?.Id && this.options && !(this.options.machineId)) {
      this.options.machineId = this._miSvc.CurrentMachine.Id ?? null;
    }

    if(options?.machineId != null){
      this.fetchMachineInfo(options.machineId);
      if (this._refreshInterval) {
        clearInterval(this._refreshInterval);
      }
      this._refreshInterval = setInterval(() => {
        this.fetchMachineInfo(options.machineId ?? '');
      }, options.refreshInterval);
    }
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    clearInterval(this._refreshInterval);
  }

  public getTranslateOwnerIdToName(a: string | undefined): string | undefined {
    if (a != undefined) {
      return this._oSvc.getOwnerNameById(a);
    } else {
      return undefined;
    }
  }

  public goToDetail(): void {
    if (this.options?.machineId) {
      void this._router.navigate(['/machine', this.options.machineId]);
    } else {
      this._notification.error(this._translation.transform('machine-is-not-selected'));
    }
  }

  private fetchMachineInfo(machineId: string): void {
    this._miSvc.dataSource.store().byKey(machineId).then((data) => {
      this.machineInfo = {...data} as MachineInfo;
    });
  }

}